module.exports = __webpack_public_path__ + "img/tracteurvert_on.dfb3deeb.gif";